import { useI18n } from '@affine/i18n';
import type { FC } from 'react';

import { BooleanToggle } from '../controls/boolean-toggle';
import type { SectionProps } from './types';

export const InlineEditSection: FC<SectionProps> = ({ row, setField }) => {
  const t = useI18n();
  return (
    <BooleanToggle
      label={t['com.streamlain.customApps.viewConfig.inlineEdit.label']()}
      description={t['com.streamlain.customApps.viewConfig.inlineEdit.desc']()}
      data-sl-field="inlineEdit"
      value={row.inlineEdit}
      onChange={v => setField('inlineEdit', v)}
    />
  );
};
